import React from 'react';
import AccessLink from './AccessLink';
import Header from './Header';
import FormInput from './inputs/FormInput';

const Main = function () {
  return (
    <>
      <Header />
      <FormInput />
      <AccessLink />
    </>
  );
};

export default Main;
